<p-tieredMenu
  #menu
  popup="true"
  [model]="menuItems"
  appendTo="body"
  styleClass="bfx-dashboard-menu"
></p-tieredMenu>
